import * as C from "../constants";

import {
    get_machines, post_machine, get_machine, put_machine, del_machine, get_machine_daily_sales, get_uesrs_organizations,
    get_logs
} from "utils/http";
import { parseJSON } from "utils/misc";

import { logout } from "./auth";
import { history } from "../history";

export function getMachinesRequest(){
    return {
        type: C.GET_MACHINES_REQUEST
    }
}

export function getMachinesFailure() {
    return {
        type: C.GET_MACHINES_FAILURE
    }
}

export function getMachinesSuccess(data) {
    return {
        type: C.GET_MACHINES_SUCCESS,
        payload: data,
    }
}

export function getMachineRequest() {
    return {
        type: C.GET_MACHINE_REQUEST
    }
}

export function getMachineFailure() {
    return {
        type: C.GET_MACHINE_FAILURE,
    }
}

export function getMachineSuccess(data) {
    return {
        type: C.GET_MACHINE_SUCCESS,
        payload: data,
    }
}

export function createMachineSuccess(data) {
    return {
        type: C.CREATE_MACHINE,
        payload: data,
    }
}

export function createMachineFailure() {
    return {
        type: C.CREATE_MACHINE_FAILURE
    }
}

export function editMachineSuccess(data) {
    return {
        type: C.EDIT_MACHINE,
        payload: data
    }
}

export function editMachineFailure() {
    return {
        type: C.EDIT_MACHINE_FAILURE
    }
}

export function deleteMachineSuccess(id) {
    return {
        type: C.DELETE_MACHINE,
        payload: id,
    }
}

export function deleteMachineFailure() {
    return {
        type: C.DELETE_MACHINE_FAILURE
    }
}

export function getMachineDailySalesRequest() {
    return {
        type: C.GET_MACHINE_DAILY_SALES_REQUEST
    }
}

export function getMachineDailySalesFailure() {
    return {
        type: C.GET_MACHINE_DAILY_SALES_FAILURE
    }
}

export function getMachineDailySalesSuccess(data) {
    return {
        type: C.GET_MACHINE_DAILY_SALES_SUCCESS,
        payload: data,
    }
}

export function getMachinesOrganizationsRequest() {
    return {
        type: C.GET_MACHINES_ORGANIZATIONS_REQUEST
    }
}

export function getMachinesOrganizationsFailure() {
    return {
        type: C.GET_MACHINES_ORGANIZATIONS_FAILURE
    }
}

export function getMachinesOrganizationsSuccess(data) {
    return {
        type: C.GET_MACHINES_ORGANIZATIONS_SUCCESS,
        payload: data,
    }
}

export function getMachineLogsRequest() {
    return {
        type: C.GET_MACHINE_LOGS_REQUEST
    }
}

export function getMachineLogsFailure() {
    return {
        type: C.GET_MACHINE_LOGS_FAILURE
    }
}

export function getMachineLogsSuccess(data) {
    return {
        type: C.GET_MACHINE_LOGS_SUCCESS,
        payload: data,
    }
}

export function getMachines(token, page, rows_per_page){
    return function (dispatch) {
        dispatch(getMachinesRequest());
        return get_machines(token, page, rows_per_page)
            .then(parseJSON).then(response => {
                dispatch(getMachinesSuccess(response))
        }).catch(error => {
            dispatch(getMachinesFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function getMachine(token, id){
    return function (dispatch) {
        dispatch(getMachineRequest());
        return get_machine(token, id)
            .then(parseJSON).then(response => {
                dispatch(getMachineSuccess(response))
            }).catch(error => {
                dispatch(getMachineFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function createMachine(token, machine) {
    return function (dispatch) {
        dispatch(createMachineFailure());
        return post_machine(token, machine).then(parseJSON).then(response => {
            dispatch(createMachineSuccess(response));
            history.replace(`/machines/${response.id}`);
            return response
        }).catch(error => {
            dispatch(getMachineFailure());
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                history.replace("/login");
            }
        })
    }
}

export function editMachine(token, machine) {
    return function (dispatch) {
        return put_machine(token, machine)
            .then(parseJSON).then(response => {
                dispatch(editMachineSuccess(response));
                return response
            }).catch(error => {
                dispatch(editMachineFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function deleteMachine(token, id) {
    return function (dispatch) {
        return del_machine(token, id)
            .then(parseJSON).then(response => {
                history.replace("/machines");
                dispatch(deleteMachineSuccess(id));
            }).catch(error => {
                dispatch(deleteMachineFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getMachineDailySales(token, id, year, month, type) {
    return function (dispatch) {
        dispatch(getMachineDailySalesRequest());
        return get_machine_daily_sales(token, id, year, month, type)
            .then(parseJSON).then(response => {
                dispatch(getMachineDailySalesSuccess(response))
            }).catch(error => {
                dispatch(getMachineDailySalesFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getMachinesOrganizations(token) {
    return function (dispatch) {
        dispatch(getMachinesOrganizationsRequest());
        return get_uesrs_organizations(token)
            .then(parseJSON).then(response => {
                dispatch(getMachinesOrganizationsSuccess(response))
            }).catch(error => {
                dispatch(getMachinesOrganizationsFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getMachineLogs(token, machineId, fromDate, toDate, limit) {
    return function (dispatch) {
        dispatch(getMachineLogsRequest());
        return get_logs(token, machineId, fromDate, toDate, limit)
            .then(parseJSON).then(response => {
                dispatch(getMachineLogsSuccess(response))
            }).catch(error => {
                dispatch(getMachineLogsFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/machines.js